import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from "../../components/Footer";

const faqData = [
  {
    question: "Ce înseamnă generarea de bilete?",
    answer: "Selectând un număr de meciuri din pagina de generare, aplicația va genera un bilet cu numărul de meciuri alese și pronosticurile pentru acele meciuri. Pronosticurile nu sunt duplicate. Puteti genera din cote normale si cote mari"
  },
  {
    question: "Nu exista suficiente pronosticuri?",
    answer: "Asta înseamnă că nu există suficiente predicții pentru ziua sau zilele selectate pentru a genera un bilet cu numărul de meciuri alese."
  },
  {
    question: "Toate predicțiile",
    answer: "În pagina de predicții puteți vedea toate predicțiile cu cote normale pentru toate zilele existente în aplicație."
  },
  {
    question: "Nu pot genera / alte probleme",
    answer: "Ne puteti contacta la adresa de email gadau.andrei@gmail.com"
  },
  {
    question: "Termeni si conditii",
    answer: "Vezi Termeni si Conditii"
  }
];

const Faq = () => {
  const navigate = useNavigate();

  return (
    <div 
      className="relative bg-cover bg-no-repeat bg-center bg-fixed min-h-screen" 
      style={{ backgroundImage: "url('/assets/images/laponturi-bg2.webp')" }}
    >
      {/* Back Button */}
     

      <div className="absolute inset-0 bg-[#34495e] opacity-50 z-10"></div>
      <div className="relative z-20">

      <button
        onClick={() => navigate(-1)}
        className="absolute top-5 left-5 px-4 py-2 bg-gray-300 rounded z-10"
      >
        Back
      </button>

      {/* Content Wrapper */}
      <div className="px-5 pt-16 pb-10 max-w-[600px] mx-auto">
        <h1 className="text-white text-2xl font-bold mb-5">FAQ</h1>
        
        {faqData.map((item, index) => (
          <div key={index} className="bg-white rounded shadow p-4 mb-4">
            <h2 className="font-semibold mb-2">{item.question}</h2>

            {item.question === "Termeni si conditii" ? (
              <p className="text-sm text-gray-700">
                {/* Make the text clickable */}
                <span 
                  onClick={() => navigate('/terms')} 
                  className="text-blue-600 underline cursor-pointer"
                >
                  {item.answer}
                </span>
              </p>
            ) : (
              <p className="text-sm text-gray-700">{item.answer}</p>
            )}
          </div>
        ))}
      </div>
        <Footer />
      </div>
    </div>
  );
};

export default Faq;
